import { Component, Input, Output, EventEmitter, HostListener } from '@angular/core';
import { DomSanitizer, SafeStyle } from '@angular/platform-browser';
import { Router } from "@angular/router";
import { DataService } from '../data.service';

@Component({
  selector: 'lc-navigation-bar',
  templateUrl: './navigation-bar.component.html',
  styleUrls: ['./navigation-bar.component.scss']
})
export class NavigationBarComponent {

  scrollY: number = 0;
  show_dropdown = {
    user: false,
    zoom: false,
    assets: false,
    pages: false,
    contact: false,
    requests: false
  };
  request_form = {
    request_type: '',
    request_title: '',
    request_explainer: '',
    thank_you_header: '',
    thank_you_lines: ['We will contact you to plan a date for the demo.']
  };
  // request_type: string;
  // request_title = '';
  // request_explainer = '';

  show_request_popup = false;

  @Input('background') header_class: string = ''; // default
  @Input('text') heading_text: string = ''; // default
  @Input('mode') mode: string = 'normal';
  @Output() language: EventEmitter<string> = new EventEmitter()
  
  @HostListener('window:open_zoom_demo_popup') 
  onZoomDemoRequest() {
    this.show_popup('zoom_demo');
  };
  
  @HostListener('window:open_sonicare_demo_popup') 
  onSonicareDemoRequest() {
    this.show_popup('sonicare_demo');
  };

  @HostListener('window:open_register_popup') 
  onRegisterRequest() {
    this.show_popup('register');
  };

  constructor(
    public dataService: DataService,
    private router: Router,
    private sanitizer: DomSanitizer) {
  }

  ngOnInit() {
    const q = window.location.search;
    try{
      const req = q.split('request=')[1].toLocaleLowerCase();
      if( req.indexOf('zoom') > -1 ) this.show_popup('zoom_demo');
      if( req.indexOf('sonicare') > -1 ) this.show_popup('sonicare_demo');
      if( req.indexOf('register') > -1 ) this.show_popup('register');      
    } catch(e){

    }
  }

  toggleDropdown(type: string){
    this.show_dropdown[type] =! this.show_dropdown[type];
    if( !!this.show_dropdown[type] ) this.showDropdown(type);
  }

  showDropdown(type: string) {
    for(const attr in this.show_dropdown) this.show_dropdown[attr] = false; // reset all
    this.show_dropdown[type] = true;
  }

  hideDropdown(type: string) {
    this.show_dropdown[type] = false;
  }

  set_language(lang){
    if (this.dataService.get_language() != lang) this.dataService.change_user_language(lang);
    this.language.emit(lang);
  }

  get_current_lang(){
    return this.dataService.get_language();
  }

  goto_shop(){
    // this.dataService.show_shop = true;
    try{ window['track_event']({name:"interaction", description:"online_shop"}) }catch(e){};
    this.router.navigate(['/shop']);
    this.hideDropdown('zoom'); this.hideDropdown('user');
  }

  goto_shop_detail(){
    // this.dataService.show_shop = true;
    this.router.navigateByUrl('/shop/detail/HX6848%2F92');
  }

  show_popup(type: string) {
    this.request_form.request_type = type;
    if(type === 'zoom_demo'){
      this.request_form.request_title = 'request a ZOOM! demo';
      this.request_form.request_explainer = '';
    } else {
      if(type === 'sonicare_demo'){
        this.request_form.request_title = 'request a Sonicare demo';
        this.request_form.request_explainer = '';
      } else {
        this.request_form = this.dataService.signup_form;
      }
    }
    this.show_request_popup = true;
  }

  close_popup() {
    this.show_request_popup = false;
  }

  edit_account(){
    this.router.navigate(['/account']);
    this.hideDropdown('zoom'); this.hideDropdown('user');
  }

  logout() {
    this.hideDropdown('zoom'); this.hideDropdown('user');
    this.dataService.is_logged_in = false;
    this.dataService.logout();
    this.router.navigate(['']);
  }

  //To-do: if DE gives a GO this function should direct you to the homepage and scroll to the footer if it cant find the id on the current page
  scroll_to(id) {
    var getMeTo = document.getElementById(id);
    getMeTo.scrollIntoView({behavior: 'smooth'});
  }

}



// WEBPACK FOOTER //
// /Users/matthijs/projects/PHILIPS/philips-dental-pro/shop/src/app/navigation-bar/navigation-bar.component.ts